import React from 'react';
import styled from 'styled-components';

import { Card } from 'antd';

const StyledCard = styled(Card)`
  background-color: white;
  max-height: 125px;
  overflow-y: auto;
  .ant-card-body {
    padding: 18px 11px;
  }
`;

const BorderlessCard = ({ children, ...rest }) => {
  return (
    <StyledCard bordered={false} {...rest}>
      {children}
    </StyledCard>
  );
};

export default BorderlessCard;
